import React from "react";
import { motion } from "framer-motion";
import { FaTelegram } from "react-icons/fa";

interface telegramLink {
  name: string;
  link: string;
  username: string;
}

export const sumateraLinks: telegramLink[] = [
  {
    name: "Sumatera Barat",
    username: "@lokersumbartop",
    link: "https://t.me/lokersumbartop",
  },
  {
    name: "Padang",
    username: "@lokerpadangtop",
    link: "https://t.me/lokerpadangtop",
  },
  {
    name: "Dharmasraya dan Solok",
    username: "@lokerdharmasoloktop",
    link: "https://t.me/lokerdharmasoloktop",
  },
  {
    name: "Payakumbuh",
    username: "@lokerpayakumbuhtop",
    link: "https://t.me/lokerpayakumbuhtop",
  },
  {
    name: "Bukittinggi",
    username: "@lokerbukittinggi_top",
    link: "https://t.me/lokerbukittinggi_top",
  },
  {
    name: "Sumatera Selatan",
    username: "@lokersumseltop",
    link: "https://t.me/lokersumseltop",
  },
  {
    name: "Palembang",
    username: "@lokerpalembangtop",
    link: "https://t.me/lokerpalembangtop",
  },
  {
    name: "Muara Enim dan Lahat",
    username: "@lokermuaraenimlahattop",
    link: "https://t.me/lokermuaraenimlahattop",
  },
  {
    name: "Lampung",
    username: "@lokerlampungtop",
    link: "https://t.me/lokerlampungtop",
  },
  {
    name: "Bandar Lampung",
    username: "@lokerbdltop",
    link: "https://t.me/lokerbdltop",
  },
  {
    name: "Metro Lampung",
    username: "@lokermetrolampungtop",
    link: "https://t.me/lokermetrolampungtop",
  },
  {
    name: "Bengkulu",
    username: "@lokerbengkulutop",
    link: "https://t.me/lokerbengkulutop",
  },
  {
    name: "Bungo Bangko",
    username: "@lokerbungobangkotop",
    link: "https://t.me/lokerbungobangkotop",
  },
  {
    name: "Sumatera Utara",
    username: "@lokersumuttop",
    link: "https://t.me/lokersumuttop",
  },
  {
    name: "Medan",
    username: "@lokermedantop",
    link: "https://t.me/lokermedantop",
  },
  {
    name: "Labuhan Batu",
    username: "@lokerlabuhanbatutop",
    link: "https://t.me/lokerlabuhanbatutop",
  },
  {
    name: "Aceh",
    username: "@lokeraceh_top",
    link: "https://t.me/lokeraceh_top",
  },
  {
    name: "Banda Aceh",
    username: "@lokerbandaacehtop",
    link: "https://t.me/lokerbandaacehtop",
  },
  {
    name: "Riau",
    username: "@lokerriautop",
    link: "https://t.me/lokerriautop",
  },
  {
    name: "Kepulauan Riau",
    username: "@lokerkepritop",
    link: "https://t.me/lokerkepritop",
  },
  {
    name: "Pekanbaru",
    username: "@lokerpkutop",
    link: "https://t.me/lokerpkutop",
  },
  {
    name: "Dumai",
    username: "@lokerdumaitop",
    link: "https://t.me/lokerdumaitop",
  },
  {
    name: "Batam",
    username: "@lokerbatamtop",
    link: "https://t.me/lokerbatamtop",
  },
];

const TelegramSumatera = () => {
  return (
    <div className="relative min-h-screen w-full overflow-y-auto pb-20">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="px-4 py-8"
        >
          <img
            src="/images/telegram.svg"
            alt="Telegram"
            className="w-20 h-20 sm:w-26 sm:h-26 md:w-28 md:h-28 lg:w-28 lg:h-28 rounded-full shadow-[0_0_15px_rgba(6,182,212,0.5)] hover:shadow-[0_0_20px_rgba(6,182,212,0.7)] transition-all duration-300 object-cover mx-auto mb-6"
          />
          <h2 className="text-center font-bold text-xl md:text-2xl text-gray-300 mb-8">
            Berikut Link Akun Telegram Wilayah Sumatera
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 px-4 mx-auto"
        >
          {sumateraLinks.map((account, index) => (
            <a
              key={index}
              href={account.link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between p-4 bg-gray-800/80 backdrop-blur-sm rounded-xl hover:bg-gray-700 transition-all duration-300 group"
            >
              <FaTelegram className="text-2xl text-cyan-500 group-hover:text-cyan-400 transition-colors duration-300" />
              <div className="flex flex-col items-center justify-center">
                <h3 className="text-gray-200 font-medium">{account.name}</h3>
                <p className="text-sm text-gray-400">{account.username}</p>
              </div>
              <FaTelegram className="text-2xl text-cyan-500 group-hover:text-cyan-400 transition-colors duration-300" />
            </a>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default TelegramSumatera;
